'use client';

import React from 'react';
import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function ImpressumPage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background)', color: 'var(--foreground)' }}>
      <Header />
      <main className="max-w-3xl mx-auto px-5 md:px-10 py-16 md:py-28">
        {/* Back link */}
        <Link
          href="/"
          className="inline-flex items-center gap-2 text-sm font-medium mb-8 transition-colors min-h-[44px]"
          style={{ color: 'var(--muted-foreground)' }}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--foreground)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--muted-foreground)')}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Zurück zur Startseite
        </Link>

        {/* Page Title */}
        <h1 className="font-display font-semibold text-3xl md:text-5xl mb-10 leading-tight" style={{ color: 'var(--foreground)' }}>
          Impressum
        </h1>

        <div className="space-y-8 md:space-y-10 text-base leading-relaxed" style={{ color: 'var(--foreground)' }}>

          {/* Angaben gemäß § 5 TMG */}
          <section>
            <h2 className="font-display font-semibold text-xl mb-4" style={{ color: 'var(--foreground)' }}>
              Angaben gemäß § 5 TMG
            </h2>
            <div className="space-y-1" style={{ color: 'var(--muted-foreground)' }}>
              <p className="font-medium" style={{ color: 'var(--foreground)' }}>Buchhaltungsbüro Aktas</p>
              <p>Inhaber: Sulleyman Aktas</p>
              <p>Langstraße 6</p>
              <p>65589 Hadamar</p>
              <p>Deutschland</p>
            </div>
          </section>

          {/* Kontakt */}
          <section>
            <h2 className="font-display font-semibold text-xl mb-4" style={{ color: 'var(--foreground)' }}>
              Kontakt
            </h2>
            <div className="space-y-1" style={{ color: 'var(--muted-foreground)' }}>
              <p>
                Telefon:{' '}
                <a
                  href="tel:+4915223610151"
                  className="transition-colors"
                  style={{ color: 'var(--accent)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.8')}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
                >
                  +49 1522 3610151
                </a>
              </p>
              <p>
                E-Mail:{' '}
                <a
                  href="mailto:info@aktas-buchhaltung.de"
                  className="transition-colors"
                  style={{ color: 'var(--accent)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.8')}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
                >
                  info@aktas-buchhaltung.de
                </a>
              </p>
              <p>
                Internet:{' '}
                <a
                  href="https://www.xn--buchhaltungsbroaktas-1ec.de"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors"
                  style={{ color: 'var(--accent)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.8')}
                  onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
                >
                  www.buchhaltungsbüroaktas.de
                </a>
              </p>
            </div>
          </section>

          {/* Berufsangaben */}
          <section>
            <h2 className="font-display font-semibold text-xl mb-4" style={{ color: 'var(--foreground)' }}>
              Berufsangaben
            </h2>
            <div className="space-y-2" style={{ color: 'var(--muted-foreground)' }}>
              <p>Selbstständiger Buchhalter</p>
              <p>Tätigkeit gemäß § 6 Nr. 3 und Nr. 4 StBerG</p>
              <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
                <li>Laufende Finanzbuchhaltung</li>
                <li>Laufende Lohn- und Gehaltsabrechnung</li>
                <li>Büroservice &amp; Organisation</li>
              </ul>
              <p className="mt-3 text-sm italic">
                Hinweis: Alle Tätigkeiten erfolgen im Rahmen der nach § 6 Nr. 3 und 4 StBerG zulässigen Tätigkeiten. Es wird keine steuerliche oder rechtliche Beratung im Sinne des StBerG erbracht.
              </p>
            </div>
          </section>

          {/* Verantwortlich nach § 18 Abs. 2 MStV */}
          <section>
            <h2 className="font-display font-semibold text-xl mb-4" style={{ color: 'var(--foreground)' }}>
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <div className="space-y-1" style={{ color: 'var(--muted-foreground)' }}>
              <p className="font-medium" style={{ color: 'var(--foreground)' }}>Sulleyman Aktas</p>
              <p>nähe Limburg und Umgebung</p>
              <p>Deutschland</p>
            </div>
          </section>

          <hr style={{ borderColor: 'var(--border)' }} />

          {/* Haftung für Inhalte */}
          <section>
            <h2 className="font-display font-semibold text-xl mb-4" style={{ color: 'var(--foreground)' }}>
              Haftung für Inhalte
            </h2>
            <p style={{ color: 'var(--muted-foreground)' }}>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-3" style={{ color: 'var(--muted-foreground)' }}>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          {/* Haftung für Links */}
          <section>
            <h2 className="font-display font-semibold text-xl mb-4" style={{ color: 'var(--foreground)' }}>
              Haftung für Links
            </h2>
            <p style={{ color: 'var(--muted-foreground)' }}>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p className="mt-3" style={{ color: 'var(--muted-foreground)' }}>
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          {/* Urheberrecht */}
          <section>
            <h2 className="font-display font-semibold text-xl mb-4" style={{ color: 'var(--foreground)' }}>
              Urheberrecht
            </h2>
            <p style={{ color: 'var(--muted-foreground)' }}>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
            <p className="mt-3" style={{ color: 'var(--muted-foreground)' }}>
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>

          {/* Streitschlichtung */}
          <section>
            <h2 className="font-display font-semibold text-xl mb-4" style={{ color: 'var(--foreground)' }}>
              Streitschlichtung
            </h2>
            <p style={{ color: 'var(--muted-foreground)' }}>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors"
                style={{ color: 'var(--accent)' }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.8')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
            <p className="mt-3" style={{ color: 'var(--muted-foreground)' }}>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
}
